import { render, staticRenderFns } from "./basicSettingControl.vue?vue&type=template&id=31e62f0c&scoped=true&"
import script from "./basicSettingControl.vue?vue&type=script&lang=js&"
export * from "./basicSettingControl.vue?vue&type=script&lang=js&"
import style0 from "./basicSettingControl.vue?vue&type=style&index=0&id=31e62f0c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e62f0c",
  null
  
)

export default component.exports